<template>
    <div style="background:white" class="ve-list-page">
        <div style=" display:flex;   background:#fff;line-height:30px;height:40px ;border-bottom:2px solid #389;">
            <div style="min-width:1100px;display:flex;padding-top:3px">
                <div style="width:70px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:13px;margin-right:15px;font-weight:600">{{ $LANG('0138', '新增') }} </span></el-link>
                </div>

                <div style="font-size:12px;line-height:30px; width:55px;margin-left:10px;font-weight:600">{{ $LANG('0120', '查询字段') }}</div>
                <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" filterable  size="small" style="width:120px;  ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input ref="refinput" :placeholder="input_hold" clearable  v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:90px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
                </el-input>
                <el-dropdown @command="dropSel"   size="small" style="margin-left:5px;">
                    <el-button type="danger" size="small" style="height:31px">
                        {{ $LANG('0337', '更多') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown"  >
                        <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">{{ $LANG('0172', '导出数据') }}</el-dropdown-item>
                        <el-dropdown-item icon="iconfont icon-ziyuan" command="fldset" style="line-height:40px;height:40px">{{ $LANG('0683', '字段设置') }}</el-dropdown-item>
                        
                    </el-dropdown-menu>
                </el-dropdown>
 
            </div>
        </div> 
        <div style="width:100%" class="ve-list-page__body">
            <div class="ve-list-page__table">
            <ve-table :columns="vueCol" 
                    :table-data="tabData" 
                    :columnHiddenOption="columnHiddenOption"
                    style="margin-top:2px; "
                    :border-around="true"
                    :border-x="true" 
                    :border-y="true" 
                    :fixed-header="true"

                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :max-height="tabHeight" 
                    :virtual-scroll-option="virtualScrollOption"
                    :scroll-width="0"
                    :footer-data="footerData"
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false,}"
                    id="sale_load"
                    ref="tableRef"
                >

            </ve-table>
            </div>
            <div style="margin-top:2px" class="ve-list-page__pagination">
                <ve-pagination
                    :total="dataCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    :page-size-option="pageList"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
        <!-- 明细资料 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="min-height:200px;overflow-y:auto">
                <div class="one-div"> <span class="oneRow"> {{ $LANG('0669', '基础信息') }}</span> </div>
                <Form :model="mainRow" :label-width="120"   label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in tabArr " :key="index" >
                        <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                            <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="mainRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-select size="medium" @change="numChg(item.key)" filterable :disabled="saveFlag" v-else-if="item.key==='MODPRC'" v-model="mainRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in prcArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-select size="medium" filterable :disabled="saveFlag" v-else-if="item.key==='EMPNM'" v-model="mainRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in empArr" :key="index" :label="item.EMPNM" :value="item.EMPNM"></el-option>
                            </el-select>
                            <el-select size="medium" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="mainRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key] " :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                            </el-select>
                            <el-input size="medium"  v-else-if="item.edcss==='button'" v-model="mainRow[item.key]"  @focus="inputBtn( item.key)" style="width:100%;border:1px solid #778899"></el-input>
                            <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"   size="medium" @input="numChg(item.key)" :disabled="saveFlag||item.disabled==='Y'?true:false"  v-else-if="item.edcss==='number'" v-model="mainRow[item.key]" style="width:100%" ></el-input>   
                            <el-checkbox size="medium" :disabled="saveFlag" border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.key]" style="width:100%"></el-checkbox> 

                            <el-input size="medium" :placeholder="item.holder" type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag "  v-model="mainRow[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
     
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="!saveTag||saveFlag"  @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > {{ $LANG('0130', '保存') }} </el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确 定') }}</el-button>
            </span>
        </el-dialog>
 
 
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
 
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
 
    </div>  
</template>
<script>
 
import pubWin from '../datamgt/pubwin.vue'  
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate } from '../../api/Select' 
import repWin from '../datamgt/repWin.vue' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
 
//局部注册
export default {
    name:"dev_capacity",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '476521',
            fieldIdseq: '476521',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tableRef',
            lockedFieldKeys: ['SMPNO'],
        })
    ],
    data () {
        return {
            v_stfg:'',
            stfgWin:false,
            Accept: "png,jpg,jpeg,gif,tiff,pdf",
            tyArr:[],
            matWin:false,
            smpWin:false,
            clntArr:[],
            addWin:false,
            perFlag:'create',
            dtlRow:{},
            saveFlag:false,
            input_hold:this.$LANG('1718', '请输入查询的值'),
            promptWin:false,
            v_row:{},
            accWin:false,
            prompt:'',
  
            dtlWin:false,
            stfgColor:'',
            mainRow:{},
            clntWin:false,
            taxArr:[],
            prcArr:[{CODE:25, CNAME:'25'+this.$LANG('0260', '元次').replace(this.$LANG('2059', '次'), '/'+this.$LANG('2059', '次'))},{CODE:30, CNAME:'30'+this.$LANG('0260', '元次').replace(this.$LANG('2059', '次'), '/'+this.$LANG('2059', '次'))}], //
            listIndex:'-1',
 
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
 
            tabArr:[], //表列
            dtlData:[], //明细数据
            dtlCol:[],
            repWin:false,
            oper:'like',
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
            othBool:false,
            delArr:[],  
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            empArr:[],
            dataCount:0,
            operArr:[],
            v_stfgrow:{},
            v_index:'',
            goPage:'',
            notNull:[],
            pageIndex:1,
            imgSrc:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            pageList: [50,500,1000],
            pageSize: 50,
 
            v_exrt:1,
            feeWin:false,
            feeRow:{},
            feeData:[],
            feeFlag:'create',
            feeIndex:'',
            delFee:[],
            feeCol:[],
            saveTag:true,
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            repUrl:'',
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            v_key:'',
            btnWin:false,
            v_tabRow:{},
            v_tabIndex:'',
            matArr:[],
            chkIndex: 0,
            uploadData:{}, //上传数据
            videoFlag:false,
            ordCol:[],
 
            delImg:[],
 
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,
                
            },
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1" 
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_inputrow:{},
            loadingInstance: null,
            v_sort:'asc',
            startRowIndex: 0,
            vueCol:[],
            initCol:[],
            footerData:[],
            actitem:'one',
        }
    },
    mounted () { 
        this.showkey()
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','476521','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
 
        getBaseData('xuper_auth/getBaseData','PARENTNO','399846','','','v_sys_base','').then(res=>{
            this.tyArr =res.result
        }) 
        getBaseData('xuper_auth/getBaseData','PARENTNO','16224','','','v_sys_base','').then(res=>{
            this.matArr =res.result
        }) 
        //用户表单新增、编辑、审核、作废权限 
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','476521','v_sys_user_priv','').then(res=>{           
            let row =res.result[0]
            if (row.ISADD==='N'){ //新增
                this.addBool=true
            }if (row.ISUPD==='N'){ //修改
                this.editBool=true
            }if (row.ISDEL==='N'){ //删除
                this.delBool=true
            }if (row.ISCFM==='N'){ //审核
                this.cfmBool=true
            }if (row.ISCANCEL==='N'){ //下推
                this.cancelBool=true
            }if (row.ISOTH=='Y'){ //仅看自己的记录
                this.othBool=true
            }
            //查询数据
            this.qryTabData()
        })  
        //表单所以下拦框动态赋值
        this.comSelect()
        //人员资料
        getBaseData(this.v_url,'CORPID',this.v_corpid ,'STFG','Y','V_HR_emp','').then(res=>{
            this.empArr =res.result
        })
 
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_bs_clnt',' order by cltype').then(res=>{
            this.clntArr =res.result
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','476521','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        this.$nextTick(()=>{
            this.$refs['refinput'].focus()
        })
    },
    computed: {
        dlgWidth: function() {
            return (window.innerWidth - 160) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 165) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 160) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 455) + 'px';
        },
    },
    components: {
  
        repWin,
        pubWin ,
        VeColumnConfigDialog,
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#sale_load"),
                name: "wave",
            })
            
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        numChg(key){
            if (key =='TIMES'){
                let v_times =this.mainRow['TIMES']?this.mainRow['TIMES']:0
                if ( v_times>0){
                    this.mainRow['STDQTY'] = (3600/v_times*7.5).toFixed(0)
                }else{
                    this.mainRow['STDQTY'] =0
                }
            }
            let v_modprc =this.mainRow['MODPRC']?this.mainRow['MODPRC']:0  //换模单价
            let v_std =this.mainRow['STDQTY']?this.mainRow['STDQTY']:0  //标准数量
            console.log(v_std,'std')
            if ( v_std>0){
                this.mainRow['PRC'] = (7500/28/v_std ).toFixed(2)
            }else{
                this.mainRow['PRC'] =0
            }
            let v_prc =this.mainRow['PRC']?this.mainRow['PRC']:0  //单价
 
            let v_qty =this.mainRow['QTY']?this.mainRow['QTY']:0
            let v_badhr =this.mainRow['BADHR']?this.mainRow['BADHR']:0  //异常小时
            let v_chgmod =this.mainRow['CHGMOD']?this.mainRow['CHGMOD']:0  //换模次数
            let v_min = this.mainRow['MINAMT']?this.mainRow['MINAMT']:0 //最低金额
            //7500/28/8*badjr
            this.mainRow['DAYSAL'] = Number((v_qty * v_prc + (v_modprc * v_chgmod)  +(7500/28/8 * v_badhr)).toFixed(2) )+Number(v_min)
            
        },
        delRec(row ,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ ,p_table:'ord_dayqty'},
                }).then(res=>{ 
                    if(res.code==='200'){
                        this.tabData.splice(index,1)
                    }
                })
            }).catch(()=>{})
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='QTY' ||column.property==='AMT'||column.property==='PCQTY'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(2)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        getFootSum(){
            let v_foot ={}
            const targetKeys = [ 'DAYSAL','QTY' ]
            // 初始化累加器对象
            const initialAcc = targetKeys.reduce((acc, key) => {
                acc[key] = 0
                return acc
            }, {})
            // 单次 reduce 计算所有总和
            const totals = this.tabData.reduce((acc, cur) => {
                targetKeys.forEach(key => {
                    // 累加当前 key 的值，处理 undefined/null 情况
                    acc[key] += Number(cur[key]) || 0
                });
                return acc
            }, initialAcc)
            // 格式化并赋值
            targetKeys.forEach(key => {
                const val = totals[key];
                v_foot[key] = val > 0 ? val.toLocaleString() : '';
            })
            let v_obj =Object.assign({
                    rowKey: 0,
                    index: this.$LANG('0280', '合计'),
                }, v_foot)
            this.footerData =[  v_obj ]
        } , 
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabArr.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]==null?'':a[v_key].toUpperCase() 
                    let nameB = b[v_key]==null?'':b[v_key].toUpperCase()    
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        enterDown(event){
            if (event.keyCode==13){
                this.qryTabData()
            }
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },

        dropSel(val){
            if (val =='expdata'){ //导出数据
                //导出
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/report/GenExcel',
                    data: {p_idseq:'476521',p_lstseq:'1',p_json:JSON.stringify(this.allData),p_action:'产量报工'},
                    responseType:'blob' //关键，声明响应类型为二进制流
                }).then(response=>{ 
                    // 从响应头解析后端设置的文件名
                    // 创建Blob对象并触发下载  创建下载链接
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob)
                    link.download = this.$LANG('0551', '产量报工')+'_'+getDate('full')+'.xls'
                    link.click()
                    URL.revokeObjectURL(link.href)

                })
            } else if (val =='fldset'){  //字段设置显示--隐藏
                this.openFieldSettingsDialog().catch(error => {
                    this.promptWin =true
                    this.prompt =error.message || this.$LANG('1225', '字段显示设置')
                })
            } 
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
        //对指定列进行合计
        getTabSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =this.allData.map(item=>Number(item[column.property]));
                if(column.property==='QTY' ){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.v_inputrow={}
            this.qryTabData()
        } ,
 
        //预览PDF
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
  
        qtyPrc(row,index,key){
            if (key=='PRC'|| key=='QTY' ){
                let v_amt=0
                if ( row['QTY'] && row['PRC']){
                    v_amt =(Number(row['QTY'])*Number( row['PRC'] )).toFixed(2)
                }
                this.dtlData.splice(index,1, Object.assign(row,{ AMT: v_amt} ))
            
            }
            this.$forceUpdate()
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
  
        btnSure(obj){
            if (this.v_key =='ORDNO'){ // 销售订单
                this.mainRow['ORDQTY'] =obj.QTY
                this.mainRow['ORDNO'] =obj.IDNO
                this.mainRow['MATNM'] =obj.MATNM    
                this.mainRow['REFIDSEQ'] =obj.IDSEQ 
                this.mainRow['REFLSTSEQ'] =obj.LSTSEQ 
            } 
            this.btnWin =false
        },
        inputBtn( key){   
            this.v_key =key         
            if (key =='ORDNO'){ // 销售订单
                this.v_table ='v_orditm'
                this.tableCol =this.ordCol
                this.v_key2 =''
                this.v_value2 =''
                this.btnWin =true
            }
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
 
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
             
            }
 
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
  
        accOk(id,val){
            this.feeRow['ACNO']=id
            this.feeRow['ACNM']=val
            this.accWin=false
        },
        feeSure(){
            if (!this.feeRow['FEENO']){
                this.promptWin=true
                this.prompt=this.$LANG('0394', '费用')+this.$LANG('2051', '不能为空')
            }else{
                this.feeWin =false
                if (this.feeFlag==='edit' ){ //编辑时要替换数组记录
                    this.feeData.splice(this.feeIndex,1,this.feeRow)
                }else{
                    this.feeData.push(this.feeRow)
                }
            }
        },
        feeAdd(){
            this.feeRow={QTY:1,LSTSEQ:''}
            this.feeFlag='create'
            this.feeWin=true
        },
        feeEdit(row ,index){
            this.feeRow=JSON.parse(JSON.stringify(row))
            this.feeWin=true
            this.feeFlag='edit'
            this.feeIndex=index
        } ,
        feeDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此费用记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.feeData.splice(index,1)
                this.delFee.push(row)
            }).catch(()=>{})
        },
        //明细下拉框改变事件
        selChg(key,val,arr){    
            if (key=='ORDTY'){ //订单类型
                arr.some(item=>{
                    if (item['CODE']==val){
                        Object.assign(this.dtlRow,{'ORDTYNM':item['CNAME']})
                    }
                })
            }else if (key=='FEENO'){ //费用类型
                arr.some(item=>{
                    if (item['CODE']==val){
                        Object.assign(this.feeRow,{'FEENM':item['CNAME']})
                    }
                })
            }
        },
        feeAmt(key){
            if (key=='PRC'||key=='NOPRC'||key=='QTY'||key=='RATE'){
                var v_rate=Number(this.feeRow['RATE'])
                if (key=='RATE'||key =='PRC'){
                    this.feeRow['NOPRC'] =(Number(this.feeRow['PRC'])*(100-Number(v_rate))/100).toFixed(3 )
                }
                this.feeRow['AMT']=(Number(this.feeRow['QTY'])*Number(this.feeRow['PRC'])).toFixed(2)
            }
        },
        accChoose(){
            this.accWin=true
        },
 
        //表行点击事件
        rowClick(row){
 
            
        },
        dtlClick(row){
            this.chkIndex =row.index
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        perDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此销售记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.dtlData.splice(index,1)
                this.delArr.push(row)
            }).catch(()=>{})
        },
        saleAdd(){
 
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })
            v_row={'MATTY':'PRD','ORDTY':'399847','ORDTYNM':'正式订单' }
            this.dtlData.push(v_row)
 
            this.$nextTick(()=>{
                this.$refs['refsale'].doLayout()
            }) 
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'476521',p_cond:' and lstseq in (1,2 )' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录 
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.mainRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool && this.saveTag ) {    
                this.saveTag =false
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(this.mainRow), p_table:'ord_dayqty',frmid:'476521'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        let idseq_ =res.idseq
        
                        vm.addWin =false   
                        vm.qryTabData()
                        
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            } 
 
        },
        stfgSure(){
            let v_cond=' set isfinish=\''+this.v_stfg +'\''
            this.$axios({
                method: 'post',
                url:'xuper_auth/updateRec',
                data: {p_key:'idseq',p_value:this.v_stfgrow['IDSEQ'] ,p_table:'ord',p_cond: v_cond},
            }).then(res=>{      
                if(res.code =='200')  {           
                    this.tabData.splice(this.v_index,1,Object.assign(this.v_stfgrow,{ISFINISH:this.v_stfg}))  
                    this.stfgWin =false  
                }else{
                    this.promptWin=true
                    this.prompt=res.message
                }        
            }) 
        },
        okBtn(row,index){
            if (row['STFG']=='Y'){
                this.stfgWin =true
                this.v_index =index
                this.v_stfg =row['ISFINISH']
                this.v_stfgrow=JSON.parse(JSON.stringify(row))
            }else{
                this.promptWin =true
                this.prompt =this.$LANG('1528', '单据审核后才能操作')
            }
        },
        //状态审核
        recSet(row,val,text){
            let v_bool =false
            if( text=='弃审'){
                if (this.v_usernm !==row['CHKUSER']){
                    v_bool =true
                }
            }
            if (v_bool){
                this.promptWin =true
                this.prompt =this.$LANG('0028', '当前用户:')+this.v_usernm+this.$LANG('1049', ' 与审核用户：')+row['CHKUSER']+this.$LANG('1646', ' 不同时不能弃审')
            }else{
                this.$confirm(this.$LANG('1564', '你确定要')+text+this.$LANG('1566', '此行记录吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox', 
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    var vm=this,v_cond='' ,v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser='' 
                    if (val =='K') {
                        if(text=='弃审'){
                            v_cfmdttm =''
                            v_cfmuser =''
                        }else{
                            v_cfmdttm =getDate('full')
                            v_cfmuser =this.v_usernm
                        }
                        v_cond =' set stfg=\''+val+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\',chkuser=null,chkdttm=null'
                    }else if (val =='Y'){
                        v_chkdttm =getDate('full')
                        v_chkuser =this.v_usernm
                        v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
                    }else{
                        v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                        v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\''
                    }
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'ord',p_cond: v_cond},
                    }).then(res=>{      
                        if(res.code =='200')  {           
                            vm.qryTabData()     
                        }else{
                            this.promptWin=true
                            this.prompt=res.message
                        }        
                    }) 
       
                }).catch(()=>{})
            }
        },

        //订单明细
        getOrdList(cond){
            this.loadingInstance.show()  
 
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key2:'corpid', p_value2:this.v_corpid,p_cond: cond+' order by '+this.selparam+' desc',p_table:'V_ord_dayqty'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.getFootSum()
                        this.loadingInstance.close() 
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }              
            }) 
        },
 
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.pageSize){
                this.tabData = this.allData          
            }else{
 
                    this.tabData =this.allData.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
               
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.pageIndex=index
            this.tabData = this.allData.slice(_start,_end)
            this.getFootSum()
        },
        selRec(row){

        },
        editRec(row,val){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
               this.saveFlag=false
            }
            this.mainRow =JSON.parse(JSON.stringify(row))
            this.addWin=true 
            this.saveTag =true
    
        },
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            let v_cond ='' , v_oper='' ,v_edcss='' ,cond_=''
            if (this.selparam ){ //列1
                this.tabArr.some(item=>{  
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (this.oper==='like'){
                    v_cond=v_cond+' and  '+this.selparam+'  like \'%' + this.txtparam+'%\' '
                } else{
                    if (this.txtparam){
                        if (v_edcss=='number'){
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+ this.txtparam
                        }else {
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                        }
                    }
                }               
            }
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (!v_oper){
                        v_oper ='like'
                    }
                    if (v_oper =='like'){
                        v_cond =v_cond +' and  '+item+' like \'%'+ (this.v_row[item]).trim()+'%\''
                    }else{
                        if (v_edcss =='number' ){
                            v_cond =v_cond +' and '+item+ v_oper +  this.v_row[item] 
                        }else if ( v_edcss=='date'){
                            v_cond =v_cond +' and  '+item + v_oper +'\''+this.v_row[item] +'\''          
                        }else{
                            v_cond =v_cond +' and  '+item +v_oper+'\''+ (this.v_row[item]).trim()+'\''  
                        }
                    }
                }
            })
            //console.log(v_cond)
            this.getOrdList( v_cond)
        },
        //新增客户
        addRec(){
            this.addWin =true
 
            this.mainRow={DTTM:getDate('day'), STFG:'N' ,WKMTH:'全自动',DEVNM:'300T',CORPID:this.v_corpid}
            this.saveFlag=false
          
            this.saveTag =true
        },
        //状态查询
        stfgChange(){
            this.qryTabData()
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            this.vueCol =[]
            this.tabArr =[]
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','476521','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                this.initCol =res.result
                return this.loadInitialFieldSettings().then(() => res)
            }).then((res) => {
                this.tabArr =[]
                this.vueCol =[]
                const mainFields =this.sortFieldRows(res.result)
                for (let k=0; k<mainFields.length; k++){
                    const rowField =mainFields[k]
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(rowField, vm.$store.state.lang),
                        key: rowField.key,
                        align: rowField.align,
                        width: rowField.width,
                        thide:rowField.THIDE,
                        fhide:rowField.FHIDE,
                        edcss:rowField.EDCSS,
                        disabled:rowField.DISABLED,
                        dotnum:rowField.DOTNUM,
                        sortable:rowField.SORTABLE,
                    })
                    let itcol =rowField
                    if (itcol.THIDE=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(rowField, vm.$store.state.lang),
                            key: itcol['key']  ,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}, h) => {
                                
                                    if (itcol.EDCSS =='number') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                                </div>                        
                                                <div style="display:flex">
                                                    <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                        
                                                        <option    value="=" style="height:30px;line-height:30px">=</option>
                                                        <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                        <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                        <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                    </select>
                                                    <input disabled={itcol.EDCSS=='image'} value={this.v_inputrow[column.key]} on-keydown={()=>this.enterDown(event)} on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px" size="mini"></input>
                                                </div>
                                            </div>                                   
                                        )
                                    }else if ( itcol.key=='STFG'){
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex" >
                                                    <el-select placeholder="" size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]}   on-change={()=>{this.qryTabData()}}>
                                                        <el-option  value="Y" label={this.$LANG('1976', '已审核')} ></el-option>
                                                        <el-option  value="P"  label={this.$LANG('1961', '审核中')} ></el-option>
                                                        <el-option  value="K"  label={this.$LANG('1982', '已确认')} ></el-option>
                                                        <el-option  value="N"  label={this.$LANG('2005', '未审核')} ></el-option>
                                                    </el-select>                                                          
                                                </div>
                                            </div>                                   
                                        )    
                                    }else if (itcol.EDCSS=='checkbox' && itcol.key!=='SEL'){
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex" >
                                                    <el-select placeholder="" size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]}   on-change={()=>{this.qryTabData()}}>
                                                        <el-option  value="Y" label={this.$LANG('2047', '是')} ></el-option>
                                                        <el-option  value="N"  label={this.$LANG('2044', '否')} ></el-option>
                                                    </el-select>                                                          
                                                </div>
                                            </div>                                   
                                        )    
                                    }else{
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                                </div>                        
                                                <div style="display:flex">
                                                    <input disabled={itcol.EDCSS=='image'||itcol.key=='SEL'} value={this.v_inputrow[column.key]} on-keydown={()=>this.enterDown(event)} on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px" size="mini"></input>
                                                </div>
                                            </div>                                   
                                        )
                                    }
                             
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.EDCSS=='image' ){
                                    return ( 
                                        <el-image fit="scale-down"  style="width:100%;height:30px; " src={rowVal} preview-src-list={[rowVal]}>
                                            <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                        </el-image>
                                    )
                                }else if (itcol.key=='SEL' ){
                                    return ( 
                                        <el-checkbox true-label="Y" disabled={row['STFG']!=='Y'} false-label="N" v-model={row['SEL']}  style="width:100%;"   > </el-checkbox>
                                    )
                                }else if (column.key=='IDNO') { 
                                    return (                                           
                                        <el-link  underline={false} on-click={()=>{this.repBtn( row)}}><span style=" border-bottom:1px solid red;font-size:13px;;font-weight:700  " title={rowVal}>{rowVal}</span> </el-link>    
                                    )
                                } else if (column.key=='STFG') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag> )
                                    }else if (row[itcol['key']] =='P'){
                                        return (<el-tag   size="mini" type="warning" effect="dark">{this.$LANG('1961', '审核中')}</el-tag> )
                                    }else if (row[itcol['key']] =='K'){
                                        return (<el-tag   size="mini" type="warning" effect="dark">{this.$LANG('1982', '已确认')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')} </el-tag> )
                                    }                                          
                                }else if (column.key=='ISFINISH') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-link underline={false}   on-click={()=>{this.okBtn(row,rowIndex)}} ><el-tag   size="mini" type="success" effect="dark">{this.$LANG('1974', '已完成')}</el-tag></el-link> )
                                    }else {
                                        return (<el-link underline={false}  on-click={()=>{this.okBtn(row,rowIndex)}}> <el-tag   size="mini" type="info" effect="dark">{this.$LANG('2004', '未完成')}</el-tag></el-link> )
                                    }                                          
                                }  else if (column.key=='ISTAX') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    }                                          
                                }else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "center",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', ' 清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width:170,
                    align: "center",
                    fixed:"right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row['STFG']=='N'){
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  on-click={()=>{this.editRec(row,'Y' )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.editBool} on-click={()=>{this.editRec(row,'N' )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link>
 
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.delBool} on-click={()=>{this.delRec(row, rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0257', '作废')}</span></el-link>
                                </div>                                
                            )
                        }  else if (row['STFG']=='Y'){
                            return ( 
                                <div>    
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  on-click={()=>{this.editRec(row,'Y',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.cfmBool} on-click={()=>{this.recSet(row,'N','弃审')}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0137', '弃审')}</span></el-link>
 
                                </div>                                
                            )
                        }
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                this.applyFieldSettingRows()
            })
 
   
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','123','lstseq','4','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.ordCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
 
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
        height:20px;
    }
 
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
 
</style>
<style lang="less">
    .table-foot-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #b2d3fa !important;
        font-weight:700 !important;
        padding: 2px !important;
        line-height: 25px !important;
        text-align:left !important;
        height: 15px !important;
   
    }
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class2 {
        font-size: 12px !important;
        color: rgb(134, 4, 4) !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        padding:6px !important;
    }
    .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding:2px !important;
        border-color: #808695 !important;
        height:20px !important;
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
    .el-date-editor .el-input__inner {
        padding-left: 28px;
        padding-right:0px;
    }
</style>
